import { Flex, Text } from '@chakra-ui/react';
import { Accordion } from '@morressier/alembic';
import OrganizationDetailsForm from './OrgonizationDetailsForm';
import { useUserDetailsData } from '../StepThree/signupHook';
import MultipleAffiliationForm from './MultipleAffiliationForm';
import { IUserDraft } from '@publishing-engine/domain/models';
import { useFormContext } from 'react-hook-form';
import { useEffect, useState } from 'react';

const AddressOrAffiliation = ({
  sectionTitle,
  organizationId,
  isMultipleForm,
  id,
  user,
  forceOpen
}: {
  isMultipleForm?: boolean;
  sectionTitle: string;
  organizationId: string;
  id: string;
  user?: IUserDraft | null | undefined;
  forceOpen?: boolean;
}) => {
  const { formState } = useFormContext();
  const { configs } = useUserDetailsData(organizationId || '');
  const newConfig = {
    streetAddress: configs.StreetAddress,
    department: configs.Department,
    city: configs.City,
    stateOrRegion: configs.StateOrRegion,
    postalCode: configs.PostalCode,
    country: configs.Country,
    url: configs.Url,
    organizationName: configs.OrganizationName
  };

  const [openIndices, setOpenIndices] = useState<number[]>([0]);

  useEffect(() => {
    if (forceOpen) {
      setOpenIndices([0]);
    }
  }, [forceOpen, formState]);

  return (
    <Flex direction="column" gap={3} id={id}>
      <Accordion
        chakraAccordionProps={{
          allowMultiple: true,
          allowToggle: true,
          index: openIndices,
          onChange: (indices: number | number[]) => {
            setOpenIndices(Array.isArray(indices) ? indices : [indices]);
          },
          width: 'full',
          background: 'surfacePrimaryFill',
          marginY: 2
        }}
        items={[
          {
            background: 'surfacePrimaryFill',
            title: (
              <Flex direction="column">
                <Text textStyle="headingItem">{sectionTitle}</Text>
              </Flex>
            ),
            content: isMultipleForm ? (
              <MultipleAffiliationForm
                formConfig={newConfig}
                additionalAffiliations={user?.additionalAffiliations}
              />
            ) : (
              <OrganizationDetailsForm
                formConfig={newConfig}
                fieldPrefix="affiliationDetails"
                affiliationDetails={user?.affiliationDetails || null}
              />
            )
          }
        ]}
      />
    </Flex>
  );
};

export default AddressOrAffiliation;
